var map = {
	"./audio-placeholder": 864,
	"./audio-placeholder.png": 864,
	"./avatar-missing": 635,
	"./avatar-missing.png": 635,
	"./avatar-missing.svg": 924,
	"./halloween/clouds": 865,
	"./halloween/clouds.png": 865,
	"./halloween/halloween-emblem": 876,
	"./halloween/halloween-emblem.svg": 876,
	"./halloween/spider": 877,
	"./halloween/spider.svg": 877,
	"./halloween/spiderweb": 878,
	"./halloween/spiderweb.svg": 878,
	"./halloween/starfield": 879,
	"./halloween/starfield.png": 879,
	"./halloween/twinkle": 880,
	"./halloween/twinkle.svg": 880,
	"./header-missing": 638,
	"./header-missing.png": 638,
	"./reticle": 881,
	"./reticle.png": 881,
	"./soapbox-logo": 639,
	"./soapbox-logo-white": 640,
	"./soapbox-logo-white.svg": 640,
	"./soapbox-logo.svg": 639,
	"./sprite-post-functions": 882,
	"./sprite-post-functions.png": 882,
	"./video-placeholder": 883,
	"./video-placeholder.png": 883,
	"./void": 884,
	"./void.png": 884,
	"./web-push/web-push-icon_expand": 901,
	"./web-push/web-push-icon_expand.png": 901,
	"./web-push/web-push-icon_favourite": 902,
	"./web-push/web-push-icon_favourite.png": 902,
	"./web-push/web-push-icon_reblog": 903,
	"./web-push/web-push-icon_reblog.png": 903
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 923;